module.exports = flarum.core.compat['utils/PostControls'];